import { ActivityIndicator, Text } from "react-native";
import * as React from "react";
import { ReactNode, useState } from "react";

import AceEditor from "react-ace";

import { useDocument } from "../hooks/firebase";

import "brace/mode/json";
import "brace/theme/github";
import { Bottom, Content } from "./Page";
import { CenterBox } from "./Container";
import Button from "./Button";

const JSONEditor = ({
  path,
  extraButton
}: {
  path: string;
  extraButton?: (edited: boolean) => ReactNode;
}) => {
  const { value, replace, error, loading: docLoading } = useDocument(path);
  const [loading, setLoading] = useState(false);
  const [edited, setEdited] = useState({
    error: true,
    value,
    edited: false,
    saved: false
  });

  return (
    <>
      <Content>
        {error ? (
          <Text>{error.message}</Text>
        ) : !docLoading ? (
          <AceEditor
            wrapEnabled={true}
            mode="json"
            theme="github"
            value={
              edited.value != null
                ? edited.value
                : value && JSON.stringify(value, null, 2)
            }
            onChange={text => {
              setEdited({
                ...edited,
                value: text,
                edited: true,
                saved: false
              });
            }}
            onValidate={a => {
              setEdited({
                ...edited,
                error: a.length > 0
              });
            }}
            name="EditProductQuestions"
            editorProps={{ $blockScrolling: true }}
            style={{
              width: "100%",
              height: "100%"
            }}
          />
        ) : (
          <CenterBox>
            <ActivityIndicator />
          </CenterBox>
        )}
      </Content>
      <Bottom>
        <Button
          loading={loading}
          disabled={!edited.edited || edited.error}
          title={edited.saved ? "Saved!!!" : "Save"}
          onPress={async () => {
            try {
              setLoading(true);
              await replace(JSON.parse(edited.value));
              setLoading(false);
              setEdited({
                ...edited,
                saved: true,
                edited: false
              });
            } catch (e) {
              alert(e.message);
              setLoading(false);
            }
          }}
        />
        {extraButton && extraButton(edited.edited)}
      </Bottom>
    </>
  );
};

export default JSONEditor;
